<template>
  <div class="calm login-calm">
    <!-- TH / EN locale toggle — top-right segmented control -->
    <div class="login-calm__locale">
      <button
        type="button"
        class="login-calm__seg"
        :class="{ 'is-active': this.$i18n.locale == 'th' }"
        @click="th()"
      >TH</button>
      <button
        type="button"
        class="login-calm__seg"
        :class="{ 'is-active': this.$i18n.locale == 'en' }"
        @click="en()"
      >EN</button>
    </div>

    <!-- Centered Calm login card -->
    <div class="login-calm__wrap">
      <div class="calm__card login-calm__card">
        <!-- Brand / logo -->
        <div class="login-calm__brand">
          <div class="login-calm__logo">North And East Broker</div>
          <div class="login-calm__brandmeta">
            <div class="login-calm__brandname">{{ appTitle }}</div>
            <div class="login-calm__brandsub">Backoffice</div>
          </div>
        </div>

        <h1 class="login-calm__title">{{ $t("auth.signin") }}</h1>

        <validation-observer
          v-slot="{ handleSubmit }"
          ref="formValidator"
        >
          <form role="form" @submit.prevent="handleSubmit(onSubmit)">
            <div class="fld login-calm__fld">
              <label>{{ $t("auth.username") }}</label>
              <base-input
                alternative
                name="Email"
                error="error"
                :placeholder="$t('auth.username')"
                v-model="model.email"
                autocomplete="off"
              >
              </base-input>
            </div>

            <div class="fld login-calm__fld">
              <label>{{ $t("auth.password") }}</label>
              <base-input
                alternative
                name="Password"
                type="password"
                :placeholder="$t('auth.password')"
                v-model="model.password"
                autocomplete="off"
              >
              </base-input>
            </div>

            <button
              type="submit"
              class="c-btn c-btn--primary login-calm__submit"
            >{{ $t("auth.signin") }}</button>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import VueI18n from "vue-i18n";
import { mapActions, mapGetters, matGetters } from "vuex";
import swal from "sweetalert2";
const qs = require("querystring");

export default {
  data() {
    return {
      model: {
        email: process.env.VUE_APP_DEMO_USER,
        password: process.env.VUE_APP_DEMO_PASSWORD,
        rememberMe: false
      },
      user: "agent"
    };
  },
  computed: {
    ...mapGetters({
      getUser: "Auth/getUser"
    }),
    appTitle() {
      return process.env.VUE_APP_TITLE;
    },
  },
  methods: {
    ...mapActions({
      setUser: "Auth/setUser",
      SignIn: "Auth/SignIn"
    }),
    en() {
      this.$i18n.locale = "en";
    },
    th() {
      this.$i18n.locale = "th";
    },
    onSubmit() {
      this.SignIn({
        username: this.model.email,
        password: this.model.password,
        // locale: this.$i18n.locale
      })
        .then((res) => {
          console.log(res.data)
            this.$cookie.set("token", res.data.Token, { expires: "1D" });
            this.setUser(res.data.User);
            this.$router.push("/lmg");
        })
        .catch((err) => {
          swal.fire({
            title: this.$t(err.response.data.msg),
            text: ``,//this.getErrorText(err.response.data),
            size: `sm`,
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
/*
 * Calm login — consumes the global Calm system (src/assets/scss/v2/calm.scss).
 * The page root carries class="calm" so the --c-* tokens, .calm__card, .fld and
 * .c-btn classes resolve here even though AuthLayout has no .calm ancestor.
 * All selectors are namespaced under .login-calm* — no naked globals.
 */
.login-calm {
  min-height: 100vh;
  background: var(--c-bg);
  font-family: var(--c-font);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  position: relative;
}

/* ---- locale toggle (segmented) ---- */
.login-calm__locale {
  position: absolute;
  top: 24px;
  right: 24px;
  display: inline-flex;
  background: var(--c-surface);
  border: 1px solid var(--c-border);
  border-radius: 999px;
  padding: 3px;
  gap: 2px;
}
.login-calm__seg {
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--c-text-soft);
  font-family: var(--c-font);
  font-size: 12.5px;
  font-weight: 500;
  padding: 5px 14px;
  border-radius: 999px;
  cursor: pointer;
  transition: background var(--c-fast) var(--c-ease),
              color var(--c-fast) var(--c-ease);
}
.login-calm__seg:hover { color: var(--c-text); }
.login-calm__seg.is-active {
  background: var(--c-blue);
  color: #fff;
}

/* ---- centered card ---- */
.login-calm__wrap {
  width: 100%;
  max-width: 400px;
}
.login-calm__card {
  padding: 32px 30px 30px;
}

/* ---- brand ---- */
.login-calm__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 22px;
}
.login-calm__logo {
  flex: none;
  min-width: 46px;
  min-height: 46px;
  max-width: 220px;
  padding: 6px 14px;
  border-radius: 12px;
  background: var(--c-blue);
  color: #fff;
  font-weight: 700;
  font-size: 12.5px;
  line-height: 1.15;
  letter-spacing: 0.02em;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Pill that adapts to any brand length 1-30 chars; wraps cleanly for longer. */
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
.login-calm__brandname {
  font-size: 15px;
  font-weight: 600;
  color: var(--c-text);
  line-height: 1.3;
}
.login-calm__brandsub {
  font-size: 12px;
  color: var(--c-text-mute);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.login-calm__title {
  font-size: 20px;
  font-weight: 600;
  color: var(--c-text);
  margin: 0 0 22px;
}

/* ---- fields ---- */
.login-calm__fld { margin-bottom: 16px; }

/*
 * Tame the bundled Argon base-input chrome into the Calm input look. base-input
 * renders a .form-group > .input-group > input.form-control; flatten the group
 * and restyle the inner control to match .calm .ed.
 */
.login-calm__fld ::v-deep .form-group { margin-bottom: 0; }
.login-calm__fld ::v-deep .input-group {
  box-shadow: none;
  background: transparent;
  display: block;
}
.login-calm__fld ::v-deep .form-control {
  height: 40px;
  background: var(--c-surface) !important;
  border: 1px solid var(--c-border) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  font-family: var(--c-font);
  font-size: 13.5px;
  color: var(--c-text) !important;
  padding: 9px 12px;
  width: 100%;
  transition: border-color var(--c-fast) var(--c-ease),
              box-shadow var(--c-fast) var(--c-ease);
}
.login-calm__fld ::v-deep .form-control:focus {
  border-color: var(--c-blue) !important;
  box-shadow: 0 0 0 3px rgba(59, 110, 168, 0.12) !important;
  outline: none;
}
.login-calm__fld ::v-deep .form-control::placeholder { color: var(--c-text-mute); }
.login-calm__fld ::v-deep .invalid-feedback {
  font-size: 11.5px;
  color: var(--c-danger);
  margin-top: 4px;
}

/* ---- submit ---- */
.login-calm__submit {
  width: 100%;
  height: 42px;
  margin-top: 8px;
  font-size: 14px;
}
</style>
